import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TabsetComponent } from 'ngx-bootstrap';
import { GlobalConfig } from '../../entities';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HttpserviceService } from '../../service/http.service.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {
  isList: Boolean = true;
  isRoleList: Boolean = true;
  userId: any = '';
  apiUrl: any = '';
  submitted: Boolean = false;
  profile: any = {
    agentId: 0,
  };
  roleDetails: any[] = [];
  permissionDetails: any[] = [];

  constructor(
    private servicesComponent: HttpserviceService,
    private config: GlobalConfig,
    private toastr: ToastsManager
  ) { }

  ngOnInit() {
    const roles = localStorage.getItem('role');
    this.setUserId();
    this.getUserDetail();
    this.getRolesDetail();
    this.getPermissionDetail();
  }

  setUserId() {
    const userId = Number(JSON.parse(localStorage.getItem('profile')).nameid);
    if (userId != null) {
      this.userId = userId;
    }
  }

  getUserDetail() {
    this.servicesComponent.getUserDetail(this.userId)
      .then((response: any) => {
        if (response.success) {
          this.profile = response.receiveObj;
        }
      });
  }

  getRolesDetail() {
    this.servicesComponent.getRolesDetail(this.userId)
      .then((response: any) => {
        if (response.success) {
          this.roleDetails = response.receiveObj;
          this.isRoleList = response.receiveObj != null ? true : false;
        }
      });
  }

  getPermissionDetail() {
    this.servicesComponent.getUserPermissionDetail(this.userId)
      .then((response: any) => {
        if (response.success) {
          this.permissionDetails = response.receiveObj;
          this.isList = response.receiveObj != null ? true : false;
        }
      });
  }

  updateUserDetails(profileForm) {
    this.submitted = false;
    if (profileForm.valid) {
      this.servicesComponent.updateUserDetails(this.profile)
        .then((response: any) => {
          if (response.receiveObj.success) {
            this.toastr.success('userProfile update successfully.', 'Success!');
            this.getUserDetail();
          } else if (!response.receiveObj.success && response.receiveObj.checkuser.isUserName === true) {
            this.toastr.info('This userName is already exist.', 'Info!');
          } else if (!response.receiveObj.success && response.receiveObj.checkuser.isEmail === true) {
            this.toastr.info('This email is already exist.', 'Info!');
          } else if (!response.receiveObj.success && response.receiveObj.checkuser.isMatchPassword === true) {
            this.toastr.info('This oldPassword is not matched.', 'Info!');
          }
        })
        .catch(error => {
          console.log(error);
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        });
    } else {
      this.submitted = true;
    }
  }
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/userProfile/user-profile/user-profile.component.ts